import { IEmailTextBlock } from 'common/builder/blocks/blockInterfaces'
import {
  ConverterRule,
  EmailContentRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import {
  EmailContentText,
  EmailContentType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'
import { BlockType } from 'common/builder/constants/BlockType'

export const EmailTextContentConverterRule: ConverterRule<
  IEmailTextBlock,
  EmailContentText,
  EmailContentRulePayload
> = {
  predicate: (entity: IEmailTextBlock) => entity?.type === BlockType.EMAIL_TEXT,
  convert: (entity: IEmailTextBlock, { fields, flowChartButtons }) => ({
    id: entity.id,
    type: EmailContentType.TEXT,
    data: {
      text: replaceFieldsInString(entity.text, fields),
      buttons: getButtonsFromMap(entity.buttons, flowChartButtons),
    },
  }),
}
